// extracted by mini-css-extract-plugin
export default {"textOverflow":"SimpleHeader_textOverflow__V4Iw7"};